/* RESPONSIBLE TEAM: team-workflows */
import Service, { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import cached from 'embercom/lib/cached-decorator';
import ajax from 'embercom/lib/ajax';

const THIRTY_SECONDS = 30 * 1000;

interface FetchWorkflowsParams {
  workflowInstanceEntityId: string | number | undefined;
  workflowIds?: string[];
  includeCompatibleChannels?: boolean;
  type: 'reusable' | 'phone';
}

export default class WorkflowsApiService extends Service {
  @service declare appService: AppService;

  @cached({ max: 50, ttl: THIRTY_SECONDS, keyGenerator: JSON.stringify })
  async fetchWorkflows(params: FetchWorkflowsParams) {
    let workflowId = params.workflowInstanceEntityId ?? '-1';
    let url = this.getUrl(params.type, workflowId);
    return await ajax({
      url,
      type: 'GET',
      data: {
        app_id: this.appService.app.id,
        workflow_ids: params.workflowIds ?? [],
        include_compatible_channels: params.includeCompatibleChannels ?? false,
      },
    });
  }

  private getUrl(type: 'reusable' | 'phone', workflowId: string | number) {
    switch (type) {
      case 'reusable':
        return `/ember/operator_custom_bots/${workflowId}/no_trigger_bots`;
      case 'phone':
        return `/ember/operator_custom_bots/${workflowId}/phone_partial_bots`;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    workflowsApiService: WorkflowsApiService;
    'workflows-api-service': WorkflowsApiService;
  }
}
